import { createi18nInstance } from '@pletly/common';
import { resources } from './locales/index';

export const defaultNS = 'feature-check-updates';

const i18n = createi18nInstance({
	resources,
	defaultNS,
});

export default i18n;
